import request from '@/utils/request';
import { loginCompany, loginOrg } from '@/utils/LoginContext';
import { stringify } from 'qs';

export async function saveallcateWallType(payload) {
  return request(`/iwms-wms/wms/allcateWallType/save`, {
    method: 'POST',
    body: payload,
  });
}

export async function pageallcateWallType(payload) {
  return request(`/iwms-wms/wms/allcateWallType/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function modifyallcateWallType(payload) {
  return request(`/iwms-wms/wms/allcateWallType/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function deleteallcateWallType(payload) {
  return request(`/iwms-wms/wms/allcateWallType/delete?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'GET',
  });
}

export async function getByCode(payload){
  return request(`/iwms-wms/wms/allcateWallType/getByCode?code=${payload.code}&dcUuid=${payload.dcUuid}`)
}

//=========分播墙服务
export async function deleteAllocateWall(payload){
  return request(`/iwms-wms/wms/allcateWall/delete?uuid=${payload.uuid}`)
}

export async function getAllocateWall(payload){
  return request(`/iwms-wms/wms/allcateWall/get?uuid=${payload.uuid}`)
}

export async function getByCodeAndDc(payload){
  return request(`/iwms-wms/wms/allcateWall/getByCodeAndDc?code=${payload.code}&dcUuid=${payload.dcUuid}`)
}

export async function modifyAllcateWall(payload){
  return request(`/iwms-wms/wms/allcateWall/modify`,{
    method:'POST',
    body:payload
  })
}

export async function pageAllcateWall(payload){
  return request(`/iwms-wms/wms/allcateWall/page`,{
    method:'POST',
    body:payload
  })
}

export async function queryBin(payload){
  return request(`/iwms-wms/wms/allcateWall/queryBin`,{
    method:'POST',
    body:payload
  })
}

export async function saveAllcateWall(payload){
  return request(`/iwms-wms/wms/allcateWall/save`,{
    method:'POST',
    body:payload
  })
}
